// Shared role gates for org-wide vs user-scoped lead / opportunity visibility.
// Server handlers mirror these lists in `server/opportunity-handlers/visibility.ts`.

/** Roles that may view and filter all org leads / opportunities. */
export const ORG_WIDE_SALES_RECORD_ROLES: string[] = [
  "trainer",
  "sales_manager",
  "admin",
  "owner",
  "org_admin",
  "org_owner",
  "dev",
  "platform_owner",
  "platform_admin",
  "platform_dev",
  "platform_trainer",
];

export function canViewOrgWideSalesRecords(hasRole: (...roles: string[]) => boolean): boolean {
  return hasRole(...ORG_WIDE_SALES_RECORD_ROLES);
}
